import { inject } from '@angular/core';
import { CanActivateFn, Router, type ActivatedRouteSnapshot, type RouterStateSnapshot } from '@angular/router';
import { UserService } from '../services/user.service';
import { Role, RoleEnum } from '../interfaces/application';
import { firstValueFrom } from 'rxjs';

export const hasPermissionGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const userService: UserService = inject(UserService);

  const permission = route.data['permission'];

  const hasPermission = (roles: Role[], permission: string): boolean => {
    return roles.some(role => role.name === RoleEnum.MASTER || role.permissions.some(p => p.name === permission)) || false
  }

  const hasAnyPermission = (roles: Role[], permissions: string[]): boolean => {
    return permissions.some(perm => hasPermission(roles, perm));
  }

  const user = await firstValueFrom(userService.me());

  if (!user || !user.success) {
    await router.navigate(['forbidden']);
    return false;
  }

  // Suporta tanto string única quanto array de permissões
  const userHasAccess = Array.isArray(permission)
    ? hasAnyPermission(user.data.roles, permission)
    : hasPermission(user.data.roles, permission);

  if (!userHasAccess) {
    await router.navigate(['forbidden']);
    return false;
  }

  return true;
};
